import React, { useEffect } from "react";

import LandingPage from "@/containers/WomenHealthSurvey/LandingPage";

import useDisableIntercom from "@/hooks/useDisableIntercom";
import { appendHotJarScript, getCanonicalURL, renderMetaData } from "@/utils";

const WomenHealthSurveyLandingPage = () => {
  useDisableIntercom({});

  // FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  const metaData = {
    siteName: "Shyft - Women's Health Survey 2023",
    siteURL: getCanonicalURL(),
    title: "Participate in the Shyft Women's Health Survey 2023",
    description:
      "The change begins with you! Take the survey and help identify key gaps in support & awareness about Women’s Health issues in India",
    thumbnail:
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-07/Meta_image-21d656de4a94418c8ed6a9dec7ba602f.jpg",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <main>
      {metaTags}
      <LandingPage />
    </main>
  );
};

export default WomenHealthSurveyLandingPage;
